import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { DirectCarrierDeletion } from '@shipstation/connections-ui/direct';
import { noop } from 'ui-components/default-props/noop';

import { useCuiApiConfig } from './helpers/use-cui-api-config';
import { useCuiContextProps } from './helpers/use-cui-context-props';

export const CuiProviderDeletion = ({ providerApiCode, providerType, accountId, onRemoveAccount, onError = noop, onCancel = noop }) => {
  const cuiApiConfig = useCuiApiConfig();
  const cuiContextProps = useCuiContextProps();

  const contextProps = useMemo(
    () => ({
      ...cuiContextProps,
      onCancel,
      onError,
      onRemoveAccount,
    }),
    [cuiContextProps, onCancel, onError, onRemoveAccount],
  );

  return (
    <DirectCarrierDeletion
      accountId={accountId}
      apiConfig={cuiApiConfig}
      contextProps={contextProps}
      providerApiCode={providerApiCode}
      providerType={providerType}
    />
  );
};

CuiProviderDeletion.propTypes = {
  providerApiCode: PropTypes.string.isRequired,
  providerType: PropTypes.string.isRequired,
  accountId: PropTypes.string.isRequired,
  onRemoveAccount: PropTypes.func.isRequired,
  onError: PropTypes.func,
  onCancel: PropTypes.func,
};
